import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import NotFoundContact from 'prequalificationV2/pages/NotFound/NotFoundContact';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import { SignInStep } from 'prequalificationV2/pages/SignInProcess/signInStep.enums';
import OtpLogin from 'prequalificationV2/pages/SignInProcess/steps/OtpLogin';

import CreateAccount from './steps/CreateAccount';
import ForgotPassword from './steps/ForgotPassword';
import SentResetPasswordLink from './steps/SentResetPasswordLink';
import SignIn from './steps/SignIn';

const getPageByStep = (step: SignInStep | null) => {
  switch (step) {
    case SignInStep.ForgotPassword:
      return <ForgotPassword />;
    case SignInStep.PrequalOtpVerification:
      return <OtpLogin />;
    case SignInStep.ResumeProcessOtpVerification:
      return <OtpLogin isResumeProcessLink />;
    case SignInStep.CreateAccount:
      return <CreateAccount />;
    case SignInStep.SentResetPasswordLink:
      return <SentResetPasswordLink />;
    case SignInStep.NotFoundContact:
      return <NotFoundContact />;
    default:
      return <SignIn />;
  }
};

const SignInProcess = () => {
  const navigator = useAppNavigate();
  const { pathname } = useLocation();
  const currentSignInStep = useAppSelector((state) => state.stages.currentSignInStep);

  useEffect(() => {
    navigator(pathname as AppRoutes, { state: { hfsPortal: true } });
  }, []);

  return getPageByStep(currentSignInStep);
};

export default SignInProcess;
